module.exports = __webpack_public_path__ + "static/media/wordpress.37434de1.svg";